<template>
  <div class="search-subscribe">
    <div class="el-search vue-top-padding radius">
      <div class="el-left">
        <!-- <el-button type="primary" size="small" @click="accountDeductions">{{ $t('subscribe.actions.accountDeductions') }}</el-button> -->
        <el-button type="success" size="small" @click="stop">{{ $t('subscribe.actions.strip') }}</el-button>
      </div>
      <div class="el-right">
        <el-form
          ref="search"
          :model="search"
          :inline="true"
          label-width="10px"
          size="small"
          class="demo-form-inline el-input-height"
        >
          <el-form-item prop="SubscriptionId">
            <el-input
              v-model="search.SubscriptionId"
              :placeholder="$t('subscribe.search.subscriptionId')"
              @input="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item prop="machineName">
            <el-input
              v-model="search.machineName"
              :placeholder="$t('subscribe.search.machineName')"
              @input="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item prop="machineNo">
            <el-input
              v-model="search.machineNo"
              :placeholder="$t('subscribe.search.machineNo')"
              @input="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{ $t('common.search') }}</el-button>
            <el-button @click="resetSearch('search')" icon="el-icon-refresh">{{ $t('common.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchSubscribe',
  props: {
    search: Object
  },
  methods: {
    accountDeductions() {
      this.$emit('accountDeductions');
    },
    stop() {
      this.$emit('stop');
    },
onSubmit() {
      this.$emit('onSubmit', this.search);
    },
    resetSearch(formName) {
      this.$refs[formName].resetFields();
      this.$toolUtil.clearForm(this.search);
      this.$emit('resetSearch', this.search);
    }
  }
};
</script>

<style scoped></style>